import { IOnboardingComplete } from "../types";

export const SUMMARY_EMPTY_MODEL: IOnboardingComplete = {
  access: false,
  first_name: "",
  last_name: "",
  acknowledgement: false,
};
